import React from 'react';
import { Col, DatePicker, Row, Select } from 'antd';
import moment from 'moment';

import { COMPARISON_MODES } from '../utils/comparison';

const { RangePicker } = DatePicker;

const MODE_OPTIONS = [
  { value: COMPARISON_MODES.OFF, label: 'No comparison' },
  { value: COMPARISON_MODES.PREVIOUS, label: 'Previous period' },
  { value: COMPARISON_MODES.PREVIOUS_MONTH, label: 'Previous month' },
  { value: COMPARISON_MODES.CUSTOM, label: 'Custom range' },
];

// Shared GA-style comparison selector: a mode dropdown, a range picker for the
// custom mode, and the resolved "vs <range>" label. Presentational only — the
// owner supplies mode/customRange state and the computed label.
const ComparisonControls = ({
  mode = COMPARISON_MODES.OFF,
  onModeChange = () => {},
  customRange,
  onCustomRangeChange = () => {},
  comparisonLabel,
  disabled = false,
  disabledHint,
}) => (
  <Row gutter={[8, 8]} align="middle" style={{ margin: '8px 0' }}>
    <Col>
      <span style={{ marginRight: 8, color: '#636363' }}>Compare to:</span>
      <Select
        value={mode}
        onChange={onModeChange}
        options={MODE_OPTIONS}
        disabled={disabled}
        style={{ width: 180 }}
        getPopupContainer={(trigger) => trigger.parentNode}
      />
    </Col>
    {mode === COMPARISON_MODES.CUSTOM ? (
      <Col>
        <RangePicker
          value={
            customRange && customRange[0] && customRange[1]
              ? [moment(customRange[0]), moment(customRange[1])]
              : null
          }
          disabled={disabled}
          onChange={(dates) => dates && dates[0] && dates[1] && onCustomRangeChange(dates)}
        />
      </Col>
    ) : null}
    {comparisonLabel ? (
      <Col>
        <span style={{ color: '#636363' }}>vs {comparisonLabel}</span>
      </Col>
    ) : null}
    {disabled && disabledHint ? (
      <Col>
        <span style={{ color: '#b0b0b0', fontStyle: 'italic' }}>{disabledHint}</span>
      </Col>
    ) : null}
  </Row>
);

export default ComparisonControls;
